import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ANIMATIONS_NAME_MAP;
export var DEFAULT_CONTAINER_CLASS_NAME = 'continuous-scroll-container';
export var HORIZONTAL_DIRECTION = 'horizontal';
export var VERTICAL_DIRECTION = 'vertical';
export var ANIMATIONS_NAME_MAP = (_ANIMATIONS_NAME_MAP = {}, _defineProperty(_ANIMATIONS_NAME_MAP, HORIZONTAL_DIRECTION, 'horizontalScroll'), _defineProperty(_ANIMATIONS_NAME_MAP, VERTICAL_DIRECTION, 'verticalScroll'), _ANIMATIONS_NAME_MAP);